"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSpring = require("react-spring");

var _reactUseportal = _interopRequireDefault(require("react-useportal"));

var _styles = require("./styles");

var _Flex = _interopRequireDefault(require("../../Flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Modal = function Modal(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      title = _ref.title,
      close = _ref.close,
      back = _ref.back,
      colorType = _ref.colorType,
      modalStyle = _ref.modalStyle,
      disablePortal = _ref.disablePortal,
      lazyLoad = _ref.lazyLoad,
      rest = _objectWithoutProperties(_ref, ["children", "isOpen", "onClose", "title", "close", "back", "colorType", "modalStyle", "disablePortal", "lazyLoad"]);

  var _usePortal = (0, _reactUseportal["default"])(),
      Portal = _usePortal.Portal;

  var Wrapper = disablePortal ? _react.Fragment : Portal;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_reactSpring.Spring, {
    from: {
      opacity: 0,
      title: title,
      pointerEvents: 'none'
    },
    to: {
      opacity: isOpen ? 1 : 0,
      pointerEvents: isOpen ? 'auto' : 'none'
    }
  }, function (style) {
    var renderBody = /*#__PURE__*/_react["default"].createElement(_styles.Body, rest, children);

    return /*#__PURE__*/_react["default"].createElement(_styles.ModalWrapper, _extends({
      style: style,
      colorType: colorType,
      onClick: function onClick() {
        return onClose();
      }
    }, rest), /*#__PURE__*/_react["default"].createElement(_styles.StyledModal, _extends({
      modalStyle: modalStyle,
      colorType: colorType,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, rest), (close || title || back) && /*#__PURE__*/_react["default"].createElement(_styles.Header, null, /*#__PURE__*/_react["default"].createElement(_Flex["default"], null, back && /*#__PURE__*/_react["default"].createElement(_styles.Back, {
      colorType: colorType,
      onClick: function onClick() {
        return onClose();
      }
    })), /*#__PURE__*/_react["default"].createElement(_Flex["default"], null, title && /*#__PURE__*/_react["default"].createElement(_styles.Title, {
      colorType: colorType
    }, title)), /*#__PURE__*/_react["default"].createElement(_Flex["default"], null, close && /*#__PURE__*/_react["default"].createElement(_styles.Close, {
      colorType: colorType,
      onClick: function onClick() {
        return onClose();
      }
    }))), lazyLoad ? isOpen && renderBody : renderBody));
  }));
};

exports.Modal = Modal;
Modal.propTypes = {
  children: _propTypes["default"].node,
  title: _propTypes["default"].node,
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].bool,
  back: _propTypes["default"].bool,
  fullScreen: _propTypes["default"].bool,
  fullBody: _propTypes["default"].bool,
  contentWrapper: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  colorType: _propTypes["default"].string,
  modalStyle: _propTypes["default"].object,
  disablePortal: _propTypes["default"].bool,
  lazyLoad: _propTypes["default"].bool
};
var _default = Modal;
exports["default"] = _default;